/**
 * API base URL.
 * Priority:
 * 1) REACT_APP_API_URL from build-time env
 * 2) Same-origin /api when running in a browser
 * 3) Localhost fallback
 */
function getApiBaseUrl() {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/api`;
  }
  return 'http://localhost:5000/api';
}

export const API = getApiBaseUrl();
